import { render, staticRenderFns } from "./AccommodationModal.vue?vue&type=template&id=59303548"
import script from "./AccommodationModal.vue?vue&type=script&lang=js"
export * from "./AccommodationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports